/** The booking-user search in the "Give access" dialog. */
export const VEHICLE_ACCESS_USER_SEARCH = {
	minLength: 2,
	debounceMs: 300,
	maxResults: 20,
} as const;
